import { render, staticRenderFns } from "./avatarIcon.vue?vue&type=template&id=177266f8&"
import script from "./avatarIcon.vue?vue&type=script&lang=ts&"
export * from "./avatarIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports